import React, { createContext, useEffect, useState } from "react";
import {
  API_SERVICE_BACKEND_2,
  API_SERVICE_BACKEND,
  selfURL,
} from "src/config";
import { useGetUserDetail } from "src/hooks/react-query/useAuth";
import { getBlobUrl } from "src/utils/getBlobUrl";
import B2BRocketLogo from "../assets/blue icon square.png";
import B2BFaviconLogo from "../assets/favicon.ico";
import axios from "src/lib/axios";
import Cookies from "js-cookie";
import { useImagePreview } from "src/hooks/use-image-preview";
import authAxios from "src/lib/axios";
import { getSessionStorage, setSessionStorage } from "src/utils/storage";

function parseStoredTheme() {
  if (typeof window === "undefined") return null;
  const raw = window.sessionStorage.getItem("theme");
  if (raw == null || raw === "" || raw === "undefined" || raw === "null") {
    if (raw === "undefined" || raw === "null") {
      try {
        window.sessionStorage.removeItem("theme");
      } catch (e) {
        console.error("Error removing theme from sessionStorage:", e);
      }
    }
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch (error) {
    try {
      window.sessionStorage.removeItem("theme");
    } catch (error) {
      console.error("Error removing theme from sessionStorage:", error);
    }
    return null;
  }
}

function isLocalDevHostname(hostname) {
  if (!hostname) return true;
  const h = String(hostname).toLowerCase();
  return h === "localhost" || h === "127.0.0.1" || h === "[::1]" || h === "0.0.0.0";
}

// Create the context
export const WhiteLabelConfigurationContext = createContext();
export const WhiteLabelProvider = ({ children }) => {
  const theme = parseStoredTheme();
  const [user, setUser] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [logoRawUrl, setLogoRawUrl] = useState("");
  const [faviconUrl, setFaviconUrl] = useState();
  const [primaryBrandColor, setPrimaryBrandColor] = useState(theme?.primaryBrandColor || "");
  const [secondaryBrandColor, setSecondaryBrandColor] = useState(theme?.secondaryBrandColor || "");
  const [primaryTextColor, setPrimaryTextColor] = useState(theme?.primaryTextColor || "");
  const [secondaryTextColor, setSecondaryTextColor] = useState(theme?.secondaryTextColor || "");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [tagline, setTagline] = useState("");
  const [whiteLableStatus, setWhiteLableStatus] = useState(false);
  const [subUserStatus, setSubUserStatus] = useState(false);
  const [whiteLableData, setWhiteLableData] = useState("");
  const [whiteLableId, setWhiteLableId] = useState(null);
  const [domainsQuota, setDomainsQuota] = useState();
  const [whiteLabelQuota, setwhiteLabelQuota] = useState(null);
  const [staticDomainValidation, setStaticDomainValidation] = useState(false);
  const [customEmailConfigDomain, setCustomEmailConfigDomain] = useState(null);
  const [customDomainConfig, setCustomDomainConfig] = useState(null);
  const [whiteLabelConfigData, setWhiteLabelConfigData] = useState(null);
  const [integrationsShow, setIntegrationsShow] = useState(false);
  const [showCompanyName, setShowCompanyName] = useState(null);
  const [supportCenterURL, setSupportCenterURL] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isThemeLoading, setIsThemeLoading] = useState(true);
  const [isLogin, setIsLogin] = useState(true);
  const [charges, setCharges] = useState({});

  const domain = window.location.hostname;
  // const params = new URLSearchParams(window.location.search); //#test
  // const whiteLabelDomain = params.get("wl"); 

  // const effectiveDomain =
  //   whiteLabelDomain || window.location.hostname;
  //   const domain = effectiveDomain;
  const token = Cookies.get("b2b_at");

  const setDefaultValues = () => {
    setCompanyName("B2B Rocket");
    setLogoRawUrl("");
    setLogoUrl(B2BRocketLogo);
    // setFaviconUrl(B2BFaviconLogo);
    setPrimaryBrandColor("#5862ff");
    setSecondaryBrandColor("#5862ff");
    setPrimaryTextColor("#000000");
    setSecondaryTextColor("#6C737F");
    setMetaTitle("B2B Rocket");
    setMetaDescription("description");
    setTagline("tagLine");
    setSupportCenterURL(null);
    setIsLogin(false);
  };

  const { data: userDetail } = useGetUserDetail();

  const applyNoDomainWhiteLabelConfig = () => {
    setDefaultValues();
    try {
      localStorage.setItem("domain", selfURL);
    } catch (error) {
      console.error("Error saving domain to localStorage:", error);
    }
    setLoading(false);
    //setIsThemeLoading(false);
  };

  // Fetch config details for domain
  const getConfigDetails = async () => {
    setIsLogin(true);
    setLoading(true);
    if (isLocalDevHostname(domain)) {
      applyNoDomainWhiteLabelConfig();
      return;
    }
    try {
      const response = await axios.get(
        `${API_SERVICE_BACKEND}/getWhiteLabelDomainConfig?domain=${encodeURIComponent(domain)}`
      );
      const data = response.data;
      const domainConfig = data?.domainConfig;
      const hasApiError =
        data?.error != null && String(data.error).trim() !== "";

      if (response.status === 200 && domainConfig && !hasApiError) {
        setCompanyName(domainConfig?.info?.companyName ?? "B2B Rocket");
        setCustomDomainConfig(domainConfig?.customEmailConfig);
        setCustomEmailConfigDomain(domainConfig?.domain);
        // const domainLogoUrl = domainConfig?.info?.logoUrl;
        // setLogoRawUrl(domainLogoUrl || "");
        // setLogoUrl(domainLogoUrl ? (getBlobUrl(domainLogoUrl) || domainLogoUrl) : B2BRocketLogo);
        const domainLogoUrl = domainConfig?.info?.logoUrl;

        setLogoRawUrl(domainLogoUrl || "");

        const userEmail = domainConfig?.email;

        const brandingLogoUrl = domainLogoUrl
          ? `${API_SERVICE_BACKEND}/public/branding-assets?email=${userEmail}&type=logo`
          : B2BRocketLogo;

        setLogoUrl(brandingLogoUrl);
        const brandingFaviconUrl = domainConfig?.info?.favIcon
          ? `${API_SERVICE_BACKEND}/public/branding-assets?email=${userEmail}&type=favicon`
          : B2BFaviconLogo;

        setFaviconUrl(brandingFaviconUrl);
        // setFaviconUrl(domainConfig?.info?.favIcon);
        localStorage.setItem("domain", domainConfig?.domain ?? selfURL);
        if (data?.data?.metadata?.hasOwnProperty("should_show_company_name")) {
          setShowCompanyName(data.data.metadata.should_show_company_name);
        } else {
          setShowCompanyName(false);
        }
        setCharges(domainConfig?.charges ?? {});
        setPrimaryBrandColor(
          domainConfig?.theme?.primaryBrandColor || "#5862ff"
        );
        setSecondaryBrandColor(
          domainConfig?.theme?.secondaryBrandColor || "#5862ff"
        );
        setPrimaryTextColor(
          domainConfig?.theme?.primaryTextColor || "#000000"
        );
        setSecondaryTextColor(
          domainConfig?.theme?.secondaryTextColor || "#6C737F"
        );
        setMetaTitle(domainConfig?.seo?.title || "B2B Rocket");
        setMetaDescription(
          domainConfig?.seo?.description || "description"
        );
        setTagline(domainConfig?.seo?.tagLine || "tagLine");
        setSupportCenterURL(
          domainConfig?.metadata?.supportcenter || null
        );
        setIsLogin(false);
        setLoading(false);
      } else {
        applyNoDomainWhiteLabelConfig();
      }
    } catch (err) {
      applyNoDomainWhiteLabelConfig();
    }
  };

  const getUserDetails = async () => {
    try {
      const userEmail = sessionStorage.getItem("userEmail");
      if (!userEmail) {
        return;
      }
      const response = await axios.get(
        `${API_SERVICE_BACKEND}/getuserdetail?email=${encodeURIComponent(userEmail)}`
      );
      const data = response.data;
      setWhiteLableData(data?.data);
      setWhiteLableId(
        data?.data?.isWhiteLabel
          ? data?.data?._id
          : data?.data?.whiteLabelUserId
      );
      setWhiteLableStatus(data?.data?.isWhiteLabel ? true : false);
      setwhiteLabelQuota(
        data?.data?.subscription?.subscriptions?.base?.usersQuota || 5
      );
      localStorage.setItem(
        "isWhiteLabel",
        data?.data?.isWhiteLabel ? true : false
      );
    } catch (err) {
      //console.log("API fetch error:", err);
      // In case of an error during the fetch, set the default values
    }
  };
  const getUserInfo = async () => {
    try {
      const userEmail = sessionStorage.getItem("userEmail");
      if (!userEmail) {
        return;
      }
      const response = await axios.get(
        `${API_SERVICE_BACKEND}/getuserdetail?email=${encodeURIComponent(userEmail)}`
      );

      const data = response.data;
      setUser(data?.data);
      const domainsQuota =
        data?.data?.userSubscription?.subscriptions?.base?.domainsQuota === 0 ||
        data?.data?.userSubscription?.subscriptions?.base?.features?.DFY_DOMAINS
          ? data.data.userSubscription.subscriptions.base.features.DFY_DOMAINS
          : data?.data?.userSubscription?.subscriptions?.base?.domainsQuota;
      const subUserStatusValue = data?.data?.whiteLabelUserId ? true : false;
      if (!whiteLableId) {
        setWhiteLableId(
          data?.data?.isWhiteLabel
            ? data?.data?._id
            : data?.data?.whiteLabelUserId
        );
      }
      setSubUserStatus(data?.data?.whiteLabelUserId ? true : false);

      localStorage.setItem("subUserStatus", JSON.stringify(subUserStatusValue));
      setIntegrationsShow(
        data?.data?.userSubscription?.subscriptions?.base?.features?.ZAPIER &&
          data?.data?.userSubscription?.subscriptions?.base?.features
            ?.HUBSPOT &&
          data?.data?.userSubscription?.subscriptions?.base?.features?.ZOHO &&
          data?.data?.userSubscription?.subscriptions?.base?.features
            ?.SALESFORCE
          ? true
          : false
      );
      if (domainsQuota !== undefined) {
        setStaticDomainValidation(false);
        setDomainsQuota(domainsQuota);
      } else {
        setStaticDomainValidation(true);
      }
    } catch (error) {
      //console.log(error);
    }
  };
  const getAllWhiteLabelClientConfigurations = async (id) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_SERVICE_BACKEND}/getwhiteLabelConfig/${id}`
      );
      const data = response.data;
      // Check if logoUrl and favIcon are empty strings and set default values
      setCompanyName(data?.data?.info?.companyName ?? "B2B Rocket");
      if (data?.data?.metadata?.hasOwnProperty("should_show_company_name")) {
        setShowCompanyName(data.data.metadata.should_show_company_name);
      } else {
        setShowCompanyName(false);
      }

      setCustomEmailConfigDomain(data?.data?.domain);
      setCustomDomainConfig(data?.data?.customEmailConfig);
      setWhiteLabelConfigData(data?.data);
      localStorage.setItem("domain", data?.data?.domain ?? selfURL);
      // Default values in case logoUrl and favIcon are missing or empty
      // const whiteLabelLogoUrl = data?.data?.info?.logoUrl;
      // setLogoRawUrl(whiteLabelLogoUrl || "");
      // setLogoUrl(whiteLabelLogoUrl ? (getBlobUrl(whiteLabelLogoUrl) || whiteLabelLogoUrl) : B2BRocketLogo);
      // console.log('logoUrl', logoUrl);
      const clientEmail = data?.data?.email;
      const logoUrl = data?.data?.info?.logoUrl ? `${API_SERVICE_BACKEND}/public/branding-assets?email=${clientEmail}&type=logo`:"";
      setLogoUrl(logoUrl);
      // setFaviconUrl(data?.data?.info?.favIcon);
      const faviconUrl = data?.data?.info?.favIcon ? `${API_SERVICE_BACKEND}/public/branding-assets?email=${clientEmail}&type=favicon`:"";
      setFaviconUrl(faviconUrl);
      if (data?.data?.theme && typeof data.data.theme === "object") {
        setSessionStorage("theme", JSON.stringify(data.data.theme));
      }

      setPrimaryBrandColor(data?.data?.theme?.primaryBrandColor || "#5862ff"); //"#004EEB"
      setSecondaryBrandColor(
        data?.data?.theme?.secondaryBrandColor || "#5862ff"
      );
      setPrimaryTextColor(data?.data?.theme?.primaryTextColor || "#000000");
      setSecondaryTextColor(data?.data?.theme?.secondaryTextColor || "#6C737F");
      setSupportCenterURL(data?.data?.metadata?.supportcenter || null);
      setMetaTitle(data?.data?.seo?.title || "B2B Rocket");
      setMetaDescription(data?.data?.seo?.description || "description");
      setTagline(data?.data?.seo?.tagLine || "tagLine");
      setLoading(false);
      setIsThemeLoading(false);
    } catch (err) {
      setDefaultValues();
      setLoading(false);
      setIsThemeLoading(false);
    }
  };

  // Run only after auth + token (avoids getWhiteLabelDomainConfig/getuserdetail 401 before /token API)
  useEffect(() => {
    // Fetch all API data sequentially
    Promise.all([getConfigDetails(), getUserDetails(), getUserInfo()]).catch(
      (error) => {
        console.error("Error loading APIs:", error);
      }
    );
  }, [token]);
  useEffect(() => {
    if (whiteLableId) {
      const theme = getSessionStorage("theme");
      if(theme) setIsThemeLoading(false)
      getAllWhiteLabelClientConfigurations(whiteLableId);
    }
    else {
      const hasContextUser = user && typeof user === "object";
      const hasSessionEmail =
        typeof window !== "undefined" && !!sessionStorage.getItem("userEmail");
      if (hasContextUser || hasSessionEmail) {
        setIsThemeLoading(false);
      }
    }
  }, [whiteLableData, whiteLableId, token, user]);
  const faviconPreview = useImagePreview(faviconUrl, { axiosInstance: authAxios });
  useEffect(() => {
    const faviconLink = document.querySelector("link[rel='icon']");
    if (faviconLink) {
      if (loading) {
        faviconLink.href = "";
      } else {
        faviconLink.href = faviconUrl ? faviconPreview : B2BFaviconLogo;
      }
    }
  }, [loading, faviconPreview]);
  return (
    <WhiteLabelConfigurationContext.Provider
      value={{
        user,
        companyName,
        setCompanyName,
        logoUrl,
        logoRawUrl,
        getUserDetails,
        setLogoUrl,
        primaryBrandColor,
        setPrimaryBrandColor,
        secondaryBrandColor,
        setSecondaryBrandColor,
        whiteLableStatus,
        primaryTextColor,
        setPrimaryTextColor,
        secondaryTextColor,
        setSecondaryTextColor,
        metaTitle,
        faviconUrl,
        subUserStatus,
        supportCenterURL,
        whiteLableData,
        setMetaTitle,
        customEmailConfigDomain,
        whiteLabelConfigData,
        whiteLableId,
        metaDescription,
        setMetaDescription,
        whiteLabelQuota,
        getAllWhiteLabelClientConfigurations,
        tagline,
        setTagline,
        getUserInfo,
        integrationsShow,
        domainsQuota,
        showCompanyName,
        staticDomainValidation,
        customDomainConfig,
        isLogin,
        charges,
        setDefaultValues,
        isThemeLoading
      }}
    >
      {children}
    </WhiteLabelConfigurationContext.Provider>
  );
};

export const WhiteLabelConsumer = WhiteLabelConfigurationContext.Consumer;
